import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './MvSections.scss';

export default function MvSections() {
  const { t } = useI18n();
  return (
    <>
      <Section name="examples" title={t('videoGeneration.mv.examples.title')} sub={t('videoGeneration.mv.examples.sub')}>
        <div className="mv-section__grid">
          {t('videoGeneration.mv.examples.items').map((item) => (
            <article className="mv-example" key={item.title}>
              <div className="mv-example__media">{item.badge}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </Section>
      <Section name="howto" title={t('videoGeneration.mv.howto.title')} sub={t('videoGeneration.mv.howto.sub')}>
        <div className="mv-howto">
          {t('videoGeneration.mv.howto.items').map((item, idx) => (
            <React.Fragment key={item.title}>
              <div className="mv-howto__item"><span>{idx + 1}</span><h3>{item.title}</h3><p>{item.text}</p></div>
              {idx < 2 && <div className="mv-howto__arrow" />}
            </React.Fragment>
          ))}
        </div>
      </Section>
      <Section name="ask" title={t('videoGeneration.mv.ask.title')} sub={t('videoGeneration.mv.ask.sub')}>
        <div className="mv-ask">
          {t('videoGeneration.mv.ask.items').map((item, idx) => (
            <article key={item.q}>
              <span className="mv-ask__index">{String(idx + 1).padStart(2, '0')}</span>
              <div><h3>{item.q}</h3><p>{item.a}</p></div>
            </article>
          ))}
        </div>
      </Section>
    </>
  );
}

function Section({ name, title, sub, children }) {
  return (
    <section className={`mv-section mv-section--${name}`}>
      <div className="mv-section__inner">
        <h2>{title}</h2>
        <p className="mv-section__sub">{sub}</p>
        {children}
      </div>
    </section>
  );
}
